// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","customWhite":"#ffffff","caption":"_1dJD2pSCq2-UhXWE_3mRfd","textGrey":"#3f3f3f","borderGrey":"#d5dfdf","intranetToggleZIndex":"3","container":"_15eqEpSErP4HWimnFzumwE","message":"_2JjClQpDZMaV41diR8imQL _1dJD2pSCq2-UhXWE_3mRfd"};


//////////////////
// WEBPACK FOOTER
// ./src/common/intranet-toggle/IntranetToggle.css
// module id = 303
// module chunks = 0 1 2